import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import {
  SEARCH_VALUE_BY_TYPE_REQUEST,
  SEARCH_VALUE_BY_TYPE_SUCCESS,
} from '../../../search/containers/constants';
import * as actionTypes from './change-partner-constants';

export const data = handleActions(
  {
    [combineActions('LOCATION_CHANGE', actionTypes.GET_PARTNERS_REQUEST)]: () => [],
    [combineActions(
      actionTypes.GET_PARTNERS_SUCCESS,
      actionTypes.SAVE_PARTNER_DETAILS_SUCCESS,
      actionTypes.ADD_PARTNER_DETAILS_SUCCESS,
    )]: (state, { payload }) => payload.items,
  },
  [],
);

export const lastUsed = handleActions(
  {
    [combineActions('LOCATION_CHANGE', actionTypes.GET_PARTNERS_REQUEST)]: () => [],
    [combineActions(
      actionTypes.GET_PARTNERS_SUCCESS,
      actionTypes.SAVE_PARTNER_DETAILS_SUCCESS,
    )]: (state, { payload }) => payload.lastUsed || [],
  },
  [],
);


export const editedPartners = handleActions(
  {
    [combineActions('LOCATION_CHANGE', actionTypes.GET_PARTNERS_REQUEST)]: () => [],
    [combineActions(
      actionTypes.ADD_EDITED_PARTNER,
    )]: (state, { payload }) => [...state, payload],
  },
  [],
);

export const searchData = handleActions(
  {
    [combineActions('LOCATION_CHANGE', SEARCH_VALUE_BY_TYPE_REQUEST)]: () => [],
    [SEARCH_VALUE_BY_TYPE_SUCCESS]: (state, { payload }) =>
      payload.type === 'partner' ? payload.items : [],
  },
  [],
);


export const isLoading = handleActions(
  {
    [actionTypes.GET_PARTNERS_REQUEST]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.GET_PARTNERS_SUCCESS,
      actionTypes.GET_PARTNERS_FAILURE,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SAVE_PARTNER_REQUEST,
      actionTypes.SAVE_PARTNER_SUCCESS,
      actionTypes.SAVE_PARTNER_DETAILS_REQUEST,
      actionTypes.SAVE_PARTNER_DETAILS_SUCCESS,
      actionTypes.ADD_PARTNER_DETAILS_REQUEST,
      actionTypes.ADD_PARTNER_DETAILS_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.SAVE_PARTNER_FAILURE,
      actionTypes.SAVE_PARTNER_DETAILS_FAILURE,
      actionTypes.ADD_PARTNER_DETAILS_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const isSaving = handleActions(
  {
    [combineActions(
      actionTypes.SAVE_PARTNER_REQUEST,
      actionTypes.SAVE_PARTNER_DETAILS_REQUEST,
      actionTypes.ADD_PARTNER_DETAILS_REQUEST,
    )]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SAVE_PARTNER_SUCCESS,
      actionTypes.SAVE_PARTNER_FAILURE,
      actionTypes.SAVE_PARTNER_DETAILS_SUCCESS,
      actionTypes.SAVE_PARTNER_DETAILS_FAILURE,
      actionTypes.ADD_PARTNER_DETAILS_SUCCESS,
      actionTypes.ADD_PARTNER_DETAILS_FAILURE,
    )]: () => false,
  },
  false,
);


export const saveDetailsSuccess = handleActions(
  {
    [combineActions(
      actionTypes.SAVE_PARTNER_DETAILS_SUCCESS,
      actionTypes.ADD_PARTNER_DETAILS_SUCCESS,
    )]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SAVE_PARTNER_DETAILS_REQUEST,
      actionTypes.SAVE_PARTNER_DETAILS_FAILURE,
      actionTypes.ADD_PARTNER_DETAILS_REQUEST,
      actionTypes.ADD_PARTNER_DETAILS_FAILURE,
    )]: () => false,
  },
  false,
);

export const saveSuccess = handleActions(
  {
    [actionTypes.SAVE_PARTNER_SUCCESS]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SAVE_PARTNER_REQUEST,
      actionTypes.SAVE_PARTNER_FAILURE,
    )]: () => false,
  },
  false,
);

export default combineReducers({
  data,
  isLoading,
  error,
  isSaving,
  saveSuccess,
  searchData,
  lastUsed,
  saveDetailsSuccess,
  editedPartners,
});
